/* Auto-fit single-line text (the mock's fitCTA): shrink font-size in 0.25px steps until the line fits its parent. */
(() => {
  const fit = () => document.querySelectorAll('[data-sm-fit]').forEach((el) => {
    el.style.fontSize = '';
    let fs = parseFloat(getComputedStyle(el).fontSize);
    const max = el.parentElement.clientWidth;
    let guard = 0;
    while (el.scrollWidth > max + 0.5 && fs > 10 && guard++ < 80) { fs -= 0.25; el.style.fontSize = fs + 'px'; }
  });
  const run = () => { if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit); else fit(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  let t; window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(fit, 150); }, { passive: true });
  document.addEventListener('shopify:section:load', run);
})();
